export default "__VITE_ASSET__z3Lko7dx__"